import { Breakpoint } from './index.types'

export const getBreakpoint = (windowWidth: number): Breakpoint => {
  if (windowWidth < 600) {
    return Breakpoint.MOBILE;
  }

  if (windowWidth >= 600 && windowWidth < 1000) {
    return Breakpoint.TABLET;
  }

  return Breakpoint.DESKTOP;
};
